function LibVisibilite(vis) {
    switch (vis) {
    case 0: // Courriers et documents personnels
    case 3:
        return {
            Titre: 'Privé',
            Couleur: 'badge-secondary',
            Icone: 'fas fa-lock',
            Legende: 'Vous êtes le seul propriétaire qui peut voir ce document',
        };
    case 1:
        return {
            Titre: 'Public',
            Couleur: 'badge-secondary',
            Icone: 'fas fa-lock-open',
            Legende: 'Tous les propriétaires peuvent voir ce document',
        };
    case 2:
        return {
            Titre: 'Conseil syndical',
            Couleur: 'badge-cs',
            Icone: 'fas fa-unlock',
            Legende: 'Tous les membres du conseil syndical peuvent voir ce document',
        };
    default:
        return { Titre: 'Inconnu', Couleur: 'badge-secondary', Icone: 'fas fa-question-circle' };
    }
}

export default LibVisibilite;



// WEBPACK FOOTER //
// ./src/App_Data/LibVisibilite.js